import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiService from '../service/apiService';
import userService from '../service/userService';

const SSO = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = searchParams.get('t');
        const redirectUrl = searchParams.get('redirectUrl');
        const clientId = process.env.REACT_APP_SSO_CLIENT_ID;

        if (!token) {
            setError('找不到登入驗證碼，請重試。');
            setLoading(false);
            return;
        }

        const performSSOLogin = async () => {
            try {
                const resp = await apiService.apiSSOLogin({ token, clientId });
                if (resp.token) {
                    userService.setUser(resp);
                    userService.setUsername(resp.username);
                    if (redirectUrl) {
                        window.location.href = redirectUrl;
                    } else {
                        window.location.href = '/';
                    }
                } else {
                    setError('登入失敗');
                }
            } catch (err) {
                console.error('SSO login failed:', err);
                setError('登入驗證失敗，請重試。');
            } finally {
                setLoading(false);
            }
        };

        performSSOLogin();
    }, [searchParams, navigate]);

    if (loading) {
        return (
            <div className="container text-center py-5">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">驗證中，請稍候...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container text-center py-5">
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
                <button className="btn btn-primary" onClick={() => navigate('/')}>
                    返回首頁
                </button>
            </div>
        );
    }

    return null;
};

export default SSO;
